<div class="modal fade logistics-bulk-modal logistics-download-modal" id="downloadModal" tabindex="-1" role="dialog" aria-labelledby="downloadModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="downloadModalLabel">Download selected companies</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-md-12">  
                        @if (canDownload) {
                            <p class="logistics-modal-intro">Your CSV is ready to prepare for <strong>{{ selectedCompanyCount | number }}</strong> selected {{ selectedCompanyCount === 1 ? 'company' : 'companies' }}.</p>
                            <div class="logistics-modal-summary"><span>Export credits needed</span><strong>{{ selectedCompanyCount | number }} of {{ userRemainingDownloads | number }} available</strong></div>
                            
                            <div class="mb-3">                        
                            <details open>
                                <summary>Columns included in your CSV</summary>
                                <ul class="max-height-20vh mb-1">
                                    @for (item of userDownloadFormat; track $index) {
                                        <li>{{item.name || item}}</li>
                                    }
                                </ul>
                            </details>
                            <p class="logistics-modal-help">Change these columns in <a href="/account">account settings</a>.</p>
                            </div>
                            <div class="text-center">
                            <button type="button" class="rounded-btn-base rounded-btn-dark-hover control-buttons logistics-modal-primary" (click)="generateCSVDownloadUrl()" [attr.disabled]="isLoading().loadingDownloadUrl || downloadUrl || downloadRequestId ? 'disabled': null"><i class="fal fa-spinner fa-spin" *ngIf="isLoading().loadingDownloadUrl"></i> Prepare download</button>
                            </div>
                        } @else {                        
                            <p class="logistics-modal-intro">{{ selectedCompanyCount | number }} companies selected. You have {{ userRemainingDownloads | number }} downloads remaining and may download up to {{ userIndividualDownloadLimit | number }} per request. Adjust your selection to fit these limits.</p>
                        
                        }
                    </div>
                </div>

                <div class="row xsmall-margin-top" *ngIf="downloadUrl">
                    <div class="col-md-12">
                        <span>Your download has been generated and should start automatically. To start the download, please enable popups if you have not already.</span>
                    </div>
                </div>
                <div class="row xsmall-margin-top" *ngIf="downloadRequestId">
                    <div class="col-md-12">
                        <span>Your download has been queued and you will receive an email with a link when this is completed.</span>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
